<template>
    <div class="row" v-if="goal">
        <div class="position-relative">
            <transition-group name="fade" mode="in-out">
                <div class="row pt-2" :key="'chart'">
                    <div class="col-12">
                        <goals-chart :goal="goal" :trackers="trackers"></goals-chart>
                    </div>
                </div>
                <div class="row pt-2" :key="'rename-axes'">
                    <div class="col-12">
                        <goals-rename-axes :goal="goal"></goals-rename-axes>
                    </div>
                </div>
                <div class="row pt-2" :key="'phase-change'">
                    <div class="col-12">
                        <goals-phase-change
                            v-if="canAddEditGoals"
                            :user-id="userId"
                            :goal="goal"
                            @goal-updated="$emit('goal-updated')"
                        ></goals-phase-change>
                    </div>
                </div>
                <div class="row pt-2" :key="'description'">
                    <div class="col-12 col-sm-9 p-1 p-sm-2">
                        <goals-description-probe
                            :goal="goal"
                            @goal-updated="$emit('goal-updated')"
                        ></goals-description-probe>
                    </div>
                    <div class="col-12 col-sm-3 p-1 p-sm-2">
                        <goals-progress-probe
                            :goal="goal"
                            :targets="goal.parameters.targets"
                        ></goals-progress-probe>
                        <goals-average-score
                            v-if="goal"
                            :id="`score-sm-${goal.id}`"
                            :stack="true"
                            :title="'Mastered complete'"
                            :progress="
                                goal.parameters.targets.length && goal.parameters.goal
                                    ? parseInt(
                                          (100 *
                                              goal.parameters.targets.filter(t => t.mastered)
                                                  .length) /
                                              goal.parameters.goal
                                      )
                                    : 0
                            "
                            :color="helpers._get(goal, 'domain.color', '#8f8f8f')"
                        ></goals-average-score>
                    </div>
                </div>
                <div class="row pt-2" :key="'implementation-homework'">
                    <div class="col-12">
                        <goals-instructions
                            :goal="goal"
                            :can-edit="canAddEditGoals"
                            @goal-updated="$emit('goal-updated')"
                        ></goals-instructions>
                    </div>
                </div>
                <div class="d-flex justify-content-between align-content-center" :key="'history'">
                    <p class="text-uppercase">Data history</p>
                    <p
                        v-if="false"
                        class="text-primary text-uppercase font-weight-bold cursor-pointer"
                    >
                        <i class="fa fa-fw fa-filter mr-2"></i>Filter
                    </p>
                </div>
                <div class="row" :key="'new-data'">
                    <div class="col-12">
                        <goals-new-data
                            :goal="goal"
                            @refresh-trackers="getTrackers"
                        ></goals-new-data>
                    </div>
                </div>
                <div class="row pb-2 position-relative" :key="'tracker-data'">
                    <div class="col-12">
                        <goals-data-probe
                            @select-target="targetDetails($event)"
                            @refresh-trackers="getTrackers()"
                            @goal-updated="$emit('goal-updated')"
                            v-for="(target, index) in goal.parameters.targets"
                            :key="index"
                            :goal="goal"
                            :target="target"
                            :trackers="trackers"
                            :grouped-trackers="trackersGroupedByTarget[target.name]"
                        ></goals-data-probe>
                    </div>
                </div>
            </transition-group>
        </div>
    </div>
</template>
<script>
import GoalsAverageScore from "./GoalsAverageScore";
import GoalsDescription from "./GoalsDescription";
import GoalsProgressProbe from "./GoalsProgressProbe";
import GoalsInstructions from "./GoalsInstructions";
import GoalsNewData from "./GoalsNewData";
import GoalsDataProbe from "./GoalsDataProbe";
import GoalsChart from "./GoalsChart";
import GoalsDescriptionProbe from "./GoalsDescriptionProbe";
import GoalsRenameAxes from "./GoalsRenameAxes";
import GoalsPhaseChange from "./GoalsPhaseChange";
import { permissions } from "../../plugins/permissions";

export default {
    name: "DetailProbe",
    props: ["goal", "userId"],
    mixins: [permissions],
    components: {
        GoalsAverageScore,
        GoalsDescription,
        GoalsProgressProbe,
        GoalsInstructions,
        GoalsNewData,
        GoalsDataProbe,
        GoalsChart,
        GoalsDescriptionProbe,
        GoalsRenameAxes,
        GoalsPhaseChange,
    },
    data() {
        return {
            target: null,
            trackers: [],
            trackersGroupedByTarget: {},
        };
    },
    mounted() {
        this.getTrackers();
    },
    methods: {
        getTrackers() {
            let patientId = _.get(this.goal, "patient.id", null);
            if (patientId) {
                axios
                    .get(`/api/patients/${patientId}/goals/${this.goal.id}/trackers`)
                    .then(response => {
                        this.trackers = response.data.data;
                        this.groupTrackersByTarget();
                    });
            }
        },

        targetDetails(target) {
            this.target = target;
        },

        groupTrackersByTarget() {
            let groupedTrackers = {};

            if (
                this.goal &&
                this.goal.parameters &&
                this.goal.parameters.targets &&
                this.goal.parameters.targets.length
            ) {
                this.goal.parameters.targets.forEach(goalTarget => {
                    if (goalTarget.name) {
                        groupedTrackers[goalTarget.name] = [];
                    }
                });

                this.trackers.forEach(tracker => {
                    if (
                        tracker &&
                        tracker.data &&
                        tracker.data.targets &&
                        tracker.data.targets.length
                    ) {
                        tracker.data.targets.forEach(target => {
                            if (groupedTrackers.hasOwnProperty(target.name)) {
                                groupedTrackers[target.name].push({
                                    ...tracker,
                                    data: {
                                        targets: [target],
                                    },
                                });
                            }
                        });
                    }
                });

                this.trackersGroupedByTarget = groupedTrackers;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.overlay {
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
    z-index: 2;
    background-color: rgba(255, 255, 255, 0.7);
}
.filter {
    font-size: 0.5rem;
    font-weight: 500;
    border-radius: 0;
    background-color: #fcfcfc;
    color: #aeaeae;
}
/*.domain-filter:not(:first-child), .domain-filter:not(:first-child) {
    border-left: unset;
    border-right: unset;
}*/

/*.filter:not(:first-child), .domain-filter:not(:first-child) {
    border-left: unset;
    border-right: unset;
}*/

@media screen and (min-width: 576px) {
    .filter {
        font-size: 0.7rem;
    }
}
</style>
